import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import AccountDetails from './details';
import Offers from './offers';
import Offer from './offer';
import { useMemo } from 'react';
import useBreadcrumbs from './breadcrumbs/useBreadcrumbs';
import useBanner from './banner/useBanner';
import Orders from './orders';
import Order from './order';
import Invoices from './invocies';
import Invoice from './invoice';
import AccountSeller from './seller';
import AccountDiscount from './discounts';
import AccountEdit from './edit';
export default function ComponentSwitcher(props) {
    const [params] = useSearchParams();
    const id = useMemo(() => params.get('id'), [params]);
    const [, setBreadcrumbs] = useBreadcrumbs();
    const [, setBanner] = useBanner();
    useMemo(() => {
        setBreadcrumbs((breadcrumbs) => {
            breadcrumbs.mainLink = {
                text: props.text,
                href: props.url,
            };
            breadcrumbs.extraLinks = id ? breadcrumbs.extraLinks : [];
        });
        setBanner((banner) => {
            banner.title = props.title;
        });
    }, [setBreadcrumbs, setBanner, props.text, props.url, props.title, id]);
    switch (props.handle) {
        case 'account':
            return _jsx(AccountDetails, Object.assign({}, props));
        case 'offers':
            if (id) {
                return _jsx(Offer, { id: id, menu: props });
            }
            return _jsx(Offers, Object.assign({}, props));
        case 'orders':
            if (id) {
                return _jsx(Order, { id: id, menu: props });
            }
            return _jsx(Orders, Object.assign({}, props));
        case 'invoices':
            if (id) {
                return _jsx(Invoice, { id: id, menu: props });
            }
            return _jsx(Invoices, Object.assign({}, props));
        case 'seller':
            return _jsx(AccountSeller, {});
        case 'discounts':
            return _jsx(AccountDiscount, {});
        case 'edit':
            return _jsx(AccountEdit, {});
        default:
            return _jsx("div", { children: "Page not found!" });
    }
}
